import { NgModule } from '@angular/core';
import { DefaultComponent } from './layouts/components/default/default.component';
import { AuthGuard } from './authentication/guards/auth.guard';
import { SupportModule } from './support/support.module';
import { BlankAsideComponent } from './layouts/components/blank-aside/blank-aside.component';
import { FullWidthComponent } from './layouts/components/full-width/full-width.component';
import { ColumnViewComponent } from './layouts/components/column-view/column-view.component';
import { ErrorComponent } from './layouts/components/error/error.component';
import { HomeComponent } from './pages/home/home.page';
import { ProfilePage } from './pages/profile/profile.page';
import { FormsModule } from './forms/forms.module';
import { TextMaskModule } from 'angular2-text-mask';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { QuickAdditModule } from './quick-addit/quick-addit.module';
import { RoutingModule as RouterModule } from './routing/routing.module';
import { RoutingModuleContract } from './support/modules/interfaces/routing-module.interface';
import { RouteService } from './routing/services/route.service';
import { RoutingModule } from './support/modules/routing-module';
import { MenuModule } from './menu/menu.module';
import { PluginsModule } from './plugins/plugins.module';
import { BsDatepickerModule } from 'ngx-bootstrap';

// const LazyRoutes = [
//     {path: 'lazy', loadChildren: 'app/pages/users/users.module#UsersModule'}
// ];

@NgModule({
    imports: [
        SupportModule,
        FormsModule,
        TextMaskModule,
        CurrencyMaskModule,
        QuickAdditModule,
        RouterModule,
        MenuModule,
        PluginsModule,
        BsDatepickerModule.forRoot(),
    ],
    declarations: [
        HomeComponent,
        ProfilePage
    ],
    entryComponents: [
        HomeComponent,
        ProfilePage
    ],
    providers: [],
    exports: [
        RouterModule,
    ],
})
export class CoreRoutingModule extends RoutingModule implements RoutingModuleContract {

    public routes(routes: RouteService) {
        // Routes
        routes.registerLayout('default', DefaultComponent, true, AuthGuard);
        routes.registerLayout('column-view', ColumnViewComponent, null, AuthGuard);
        routes.registerLayout('full-width', FullWidthComponent, null, AuthGuard);
        routes.registerLayout('blank-aside', BlankAsideComponent);
        routes.registerLayout('error', ErrorComponent);

        // Pages
        routes.add('home', HomeComponent, 'test');

        routes.add('profile', ProfilePage, 'profile');

        // Lazy route -> not working with route service yet
        // routes.add('users', 'app/pages/users/users.module#UsersModule', 'users-module');

        //
        // // Tenants
        // routes.add('tenants', TenantIndexPage, 'tenants.index', {
        //     layout: 'full-width', permission: 'tenant.read'
        // });
        // routes.add('tenants/create', TenantCreatePage, 'tenants.create', { permission: 'tenant.write' });
        // routes.add('tenants/:tenant', TenantEditPage, 'tenants.show', { permission: 'tenant.read' });
        // routes.add('tenants/:tenant/edit', TenantEditPage, 'tenants.edit', { permission: 'tenant.read' });
        //
        // // Roles
        // routes.add('roles', RoleIndexPage, 'roles.index', {
        //     layout: 'full-width', permission: 'role.read'
        // });
        // routes.add('roles/create', RoleCreatePage, 'roles.create', { permission: 'role.write' });
        // routes.add('roles/:role', RoleEditPage, 'roles.show', { permission: 'role.read' });
        // routes.add('roles/:role/edit', RoleEditPage, 'roles.edit', { permission: 'role.read' });
        //
        // // Permissions
        // routes.add('permissions', PermissionIndexPage, 'permissions.index', {
        //     layout: 'full-width', permission: 'permission.read'
        // });
        // routes.add('permissions/create', PermissionCreatePage, 'permissions.create', { permission: 'permission.write' });
        // routes.add('permissions/:permission', PermissionEditPage, 'permissions.show', { permission: 'permission.read' });
        // routes.add('permissions/:permission/edit', PermissionEditPage, 'permissions.edit', { permission: 'permission.read' });
        //
        // // Entity Builder
        // routes.add('entities', EntityIndexPage, 'entities.index', { permission: 'entities.read' });
        // routes.add('entities/:entity/edit', EntityEditPage, 'entities.edit', { permission: 'entities.read' });
        //
        // // Entity Forms
        // routes.add('entities/:entity/forms/:form/edit', FormEditPage, 'entities.forms.edit', { permission: 'entity-forms.read' });
        // routes.add('entities/:entity/forms/create', FormCreatePage, 'entities.forms.create', { permission: 'entity-forms.write' });
        //
        // routes.add('settings', SettingsPage, 'settings.index', { permission: 'settings.read' });
        //
        // // Documentation routes
        // routes.add('documentation', DocumentationIndexPage, 'documentation.index', { permission: 'documentation.read' });

        // Errors, don't change the sequence of these routes.
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/core-routing.module.ts